import React, { memo, useContext, useMemo } from 'react';

import { LanguageDropdown } from 'components';
import { ContentRenderer, ContentSubpages } from '../';
import LanguagesContext from 'services/context/languagesContext';

import classes from '../Layout/Layout.module.scss';

const Content = ({
  content,
  parentSelected,
  contentSubpages,
  onContentClick
}) => {
  const contentName = content?.title ?? '';
  const { languageOptions } = useContext(LanguagesContext);
  const options = useMemo(() => {
    return (
      languageOptions?.map?.(({ short, name }) => ({
        name,
        countryFlag: short
      })) ?? null
    );
  }, [languageOptions]);

  return (
    <>
      <LanguageDropdown options={options} />
      <div onClick={onContentClick} className={classes.Header}>
        <div className={classes.HeaderTextWrapper}>
          <h1>{contentName}</h1>
        </div>
      </div>
      <div className={classes.ContentWrapper} onClick={onContentClick}>
        <div className={classes.Content}>
          {contentSubpages ? (
            <ContentSubpages
              content={content}
              parent={parentSelected}
              contentSubpages={contentSubpages}
            />
          ) : null}
          {content ? <ContentRenderer content={content} /> : null}
        </div>
      </div>
    </>
  );
};

export default memo(Content);
